import { type AsyncItemContext } from 'core/reduxAsync/types';
import { fetchRealtorAndGenerateHtmlMeta } from './exposeAsyncProps';
import { fetchFormSettings } from './formAsyncProps';

/**
 * Loads all data and side effects needed to render an expose route.
 * Keeping this composition at the route boundary lets reduxAsync handle one
 * typed page loader, just like the other modern frontend applications.
 */
export const fetchExposePage = async (context: AsyncItemContext) => {
  await Promise.all([
    fetchRealtorAndGenerateHtmlMeta(context),
    fetchFormSettings(context),
  ]);
};
